import { forwardRef } from 'react';
import BaseButton, { BaseButtonProps } from '../BaseButton';
import { LinkProps } from '../Link';
import { DirtyFormProxyButtonProps } from '../DirtyFormProxy/types';
import { RouteLinkDomPropsType } from './type';

type RouteLinkElementsProps = {
	componentClasses: string;
	domProps: RouteLinkDomPropsType;
};

const RouteLinkElements = forwardRef<
	HTMLAnchorElement,
	RouteLinkElementsProps & LinkProps & BaseButtonProps & DirtyFormProxyButtonProps
>(
	(
		{
			tagName = 'a',
			domProps,
			disabled,
			children,
			dataTestId,
			styledButton,
			componentClasses,
			icon,
			startIcon,
			...props
		},
		ref,
	) => {
		if (styledButton) {
			return (
				<BaseButton
					{...props}
					className={componentClasses}
					disabled={disabled}
					tagName={tagName}
					dataTestId={dataTestId}
					applyOnElementProps={domProps}
					ref={ref}
					startIcon={icon || startIcon}
				>
					{children}
				</BaseButton>
			);
		}

		const Tag = tagName;

		return (
			<Tag
				className={componentClasses}
				data-testid={dataTestId}
				{...domProps}
				// @ts-ignore
				ref={ref}
			>
				{children}
			</Tag>
		);
	},
);

RouteLinkElements.displayName = 'RouteLinkElements';

export { RouteLinkElements };
